import moment from "moment";

import { FacturationCode } from "@/Patient/Models/MedfarBilling/FacturationCode";

interface IMedfarBillingCustomSelectedCodeListBoxProps {
    items: Immutable.List<FacturationCode>;
    onItemRemoveCallback: (item: FacturationCode) => void;
    style?: React.CSSProperties;
}

class MedfarBillingCustomSelectedCodeListBox extends React.Component<IMedfarBillingCustomSelectedCodeListBoxProps, never> {
    public render(): JSX.Element {
        return (
            <div className="fmp-custom-item-container" style={this.props.style}>
                {this.props.items.map((item: FacturationCode) => (
                    <div key={item.Code} className="flex-container fmp-custom-item">
                        <div className="a">
                            <span onClick={() => this.removeItem(item)} className="glyphicon glyphicon-remove red-text pointer" />
                        </div>
                        <div className="b">
                            <span>{item.Code} - {item.Description}</span>
                            {item.DateAccouchement && (
                                <div style={{ marginLeft: "10px" }}>
                                    <span>{moment(item.DateAccouchement).format("YYYY/MM/DD")}</span>
                                </div>
                            )}
                            {item.DateCSST && (
                                <div style={{ marginLeft: "10px" }}>
                                    <span>{moment(item.DateCSST).format("YYYY/MM/DD")}</span>
                                </div>
                            )}
                            {item.UnitType1 && item.Mesure1 && (
                                <div style={{ marginLeft: "10px" }}>
                                    <span>{item.Mesure1} {item.UnitType1} - {item.UnitLabel1}</span>
                                </div>
                            )}
                            {!item.UnitLabel2 && !item.UnitType2 && item.Mesure2 && (
                                <div style={{ marginLeft: "10px" }}>
                                    <span>{item.Mesure2}</span>
                                </div>
                            )}
                            {(item.UnitLabel2 || item.UnitType2) && item.Mesure2 && (
                                <div style={{ marginLeft: "10px" }}>
                                    <span>{item.Mesure2} {item.UnitType2} - {item.UnitLabel2}</span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    private removeItem(item: FacturationCode): void {
        this.props.onItemRemoveCallback(item);
    }
}

export { MedfarBillingCustomSelectedCodeListBox };
